/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;



//////////////////
// WEBPACK FOOTER
// ./~/blockstack/~/form-data/lib/browser.js
// module id = 416
// module chunks = 0